'use client';
import { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import getLocal from '@/app/utils/getLocal';
import { rpcMap } from '@/constants/lang';

const SECRET_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_REGISTER_SECRET_KEY;
const mode = process.env.NEXT_PUBLIC_MODY;

export default function FormRecaptcha({ theme, callback }: any) {
    const { locale = 'us' } = getLocal();
    const recaptchaRef = useRef();
    const hl = rpcMap[locale] || rpcMap['us'];
    const onReCAPTCHAChange = async (captchaCode: string) => {
        callback && callback(captchaCode);
    };

    return (
        <div className={`form-common-recaptcha`}>
            {/* @ts-ignore */}
            <ReCAPTCHA
                ref={recaptchaRef}
                hl={hl}
                // 测试环境使用谷歌官方提供的测试key
                sitekey={mode === 'test' ? '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI' : SECRET_KEY}
                onChange={onReCAPTCHAChange}
                theme={theme === 'white' ? 'light' : 'dark'}
            />
        </div>
    );
}
